import { loadSwiperModule } from "../../core/base/swiper-loader.js";

export async function initHeroSwiper(root = document) {
  const sliders = Array.from(root.querySelectorAll(".hero-swiper"));
  if (!sliders.length) return;

  let Swiper;
  let modules;
  try {
    ({ Swiper, modules } = await loadSwiperModule("hero"));
  } catch (error) {
    console.warn("[HeroSwiper] Swiper module load failed", error);
    return;
  }

  const { Autoplay, EffectFade } = modules;

  sliders.forEach((slider) => {
    if (slider.dataset.heroSwiperReady === "true") return;
    if (!slider.querySelector(".swiper-wrapper")) return;

    slider.dataset.heroSwiperReady = "true";

    const instance = new Swiper(slider, {
      modules: [Autoplay, EffectFade].filter(Boolean),
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 2000,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    });

    slider.__heroSwiperInstance = instance;
  });
}
